import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form';
import ErrorAlert from '../../../alerts/components/BorderedAlertsWithIcons';
import { withRouter } from 'react-router-dom'
import '../../../../scss/component/reset-password.scss';
class ResetPassword extends Component {

  state = {
    errorMsg: null,
    loading: null
  }

  async onSubmit (values) {
    this.setState({
      loading: true
    })
    try {
      fetch("https://lb9sdrquj5.execute-api.us-west-2.amazonaws.com/dev6/reset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: values.email, env: process.env.REACT_APP_ENV })
      }).then(response => response.json())
        .then(res => res.body.result.err ? this.setState({ errorMsg: res.body.result.err, loading: false })
          : this.props.history.push({
            pathname: '/change-password',
            state: {
              email: values.email
            }
          }))
    } catch (e) {

    }
  }

  renderField (field) {
    const { meta: { touched, error } } = field;
    const className = `form-group ${touched && error ? 'red-text' : ''}`;


    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          id={field.id}
          value={field.value}
          type={field.type}
          placeholder={field.placeholder}
          {...field.input} />
        <div className="text-help">
          {touched ? error : ''}
        </div>
      </div>
    );
  }

  render () {
    const { handleSubmit } = this.props

    return (
      <div>
        <div className='account'>
          <div className='account__wrapper'>
            <div className='account__card'>
              <div className='account__head'>
                <h3 className='account__title'>Welcome to <span className='account__logo'>Post<span
                  className='account__logo-accent'>ure</span></span></h3>
                <h4 className='account__subhead subhead'>Reset your password</h4>
              </div>
              {this.state.errorMsg && this.state.errorMsg === "Username/client id combination not found." ?
                <div>
                  <ErrorAlert
                    level='danger'
                    msg="Username not found. Please contact your Administrator"
                    alertTag={'Error'} /></div>
                : this.state.errorMsg ?
                  <div>
                    <ErrorAlert level='danger' msg={this.state.errorMsg} alertTag={'Error'} /></div>
                  : null}
              <form className='form' onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <div className='form__form-group' >
                  {/* <label className='form__form-group-label'>Email</label> */}
                  <div className='form__form-group-field'>
                    {/* <div className='form__form-group-icon'>
                      <AccountOutlineIcon />
                    </div> */}
                    <Field
                      id='emailField'
                      name='email'
                      component={this.renderField}
                      type='email'
                      placeholder='Email'
                    />
                  </div>
                </div>

                {this.state.loading ?
                  <button
                    id='login'
                    disabled={true}
                    type='submit'
                    className='btn btn-primary account__btn account__btn--small loadingBtn'>
                    Loading. Please Wait
                </button> :
                  <button
                    id='login'
                    type='submit'
                    className='btn btn-primary account__btn account__btn--small'>Reset Password</button>}

              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function validate (values) {
  const errors = {};
  const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i; // eslint-disable-line max-len

  if (!values.email) {
    errors.email = "Email address is required";
  }

  if (!re.test(values.email)) {
    errors.email = "Please enter a valid email";
  }

  return errors
}

export default reduxForm({ form: "ResetPassword", validate })(withRouter(ResetPassword))


// WEBPACK FOOTER //
// ./src/components/account/log_in/components/ResetPassword.js